import { api } from './api';

const storedCardGetAll = async (data = null) => {
  const response = await api({
    url: `MobilExpress/storedCard/getCardList`,
    method: 'GET',
    params: data,
  });
  let result = response?.data;
  if (data?.VouId === 4) {
    result.data.cardList = response?.data?.data?.cardList?.filter((item) => item.vouId === 4);
  }
  return result;
};

const storedCardSave = async (data) => {
  const response = await api({
    url: `MobilExpress/storedCard/saveCard`,
    method: 'POST',
    data,
  });
  return response.data;
};

const deleteCard = async (data) => {
  const response = await api({
    url: `MobilExpress/storedCard/deleteCard`,
    method: 'DELETE',
    data,
  });
  return response.data;
};

const getCardWithVouList = (data = null) => {
  return storedCardGetAll(data);
};

const setCreditCardMatchVous = async (data) => {
  const response = await api({
    url: `MobilExpress/CreditCards/setCreditCardMatchVous`,
    method: 'PUT',
    data,
  });
  return response.data;
};

const updateProvisionDay = async (data) => {
  const response = await api({
    url: `MobilExpress/CreditCards/UpdateProvisionDay`,
    method: 'PUT',
    data,
  });
  return response.data;
};

const processPayment = async (data) => {
  const response = await api({
    url: `MobilExpress/paymentGateway/processPayment`,
    method: 'POST',
    data,
  });
  return response.data;
};

const finishPaymentProcess = async (data) => {
  const response = await api({
    url: `MobilExpress/paymentGateway/finishPaymentProcess`,
    method: 'POST',
    data,
  });
  return response.data;
};

const getBankOfBinNumber = async (data) => {
  const response = await api({
    url: `MobilExpress/paymentGateway/getBankOfBinNumber`,
    method: 'GET',
    params: data,
    headers: {
      'x-dont-document-blur': true,
    },
  });
  return response.data;
};

const Cancel = async (data) => {
  const response = await api({
    url: `MobilExpress/paymentGateway/Cancel`,
    method: 'POST',
    data,
  });
  return response.data;
};

const mobilExpressServices = {
  storedCardGetAll,
  storedCardSave,
  processPayment,
  finishPaymentProcess,
  getBankOfBinNumber,
  setCreditCardMatchVous,
  deleteCard,
  getCardWithVouList,
  updateProvisionDay,
  Cancel,
};

export default mobilExpressServices;
